import {
    Dialog,
    DialogTitle,
    IconButton,
    Typography,
    DialogContent,
    Box,
    Avatar,
    Stack,
} from "@mui/material";

import React from "react";
import avatarAlt from "../../utils/avatarAlt";
import { ArrowBack } from "@mui/icons-material";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDetailBarangModal } from "../../context/detailBarangModalContext";

interface IModalDetailBarangProps {}

const ModalDetailBarang = (props: IModalDetailBarangProps) => {
    const { isOpenModalDetailBarang, closeModalDetailBarang, data } =
        useDetailBarangModal();

    return (
        <Dialog
            maxWidth="xs"
            fullWidth={true}
            open={isOpenModalDetailBarang}
            onClose={closeModalDetailBarang}
            PaperProps={{
                sx: {
                    //   minHeight: "150px",
                    //   maxHeight: "150px",
                    borderRadius: 1,
                },
            }}
        >
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton onClick={closeModalDetailBarang}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" fontWeight="bold">
                        Detail Barang
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Box display="flex" justifyContent="center">
                    {data.multipleGambar.length > 1 ? (
                        <Slider
                            className="custom-slick"
                            dots={
                                data.multipleGambar.length === 0 ? false : true
                            }
                            infinite={
                                data.multipleGambar.length === 0 ? false : true
                            }
                            speed={500}
                            slidesToShow={1}
                            slidesToScroll={1}
                            arrows={
                                data.multipleGambar.length === 0 ? false : true
                            }
                        >
                            {data.multipleGambar &&
                            data.multipleGambar.length > 0
                                ? data.multipleGambar.map((li) => (
                                      <Avatar
                                          key={li.id}
                                          src={data.gambar ?? null}
                                          sx={{
                                              bgcolor: "primary.main",
                                              width: "30vh",
                                              height: "30vh",
                                              display: "flex",
                                              fontSize: "3em",
                                          }}
                                          variant="rounded"
                                          alt={data.namaBarang}
                                      >
                                          {avatarAlt(data.namaBarang)}
                                      </Avatar>
                                  ))
                                : null}
                        </Slider>
                    ) : data.multipleGambar.length === 1 ? (
                        <Avatar
                            src={data.multipleGambar[0].gambar}
                            sx={{
                                bgcolor: "primary.main",
                                width: "30vh",
                                height: "30vh",
                                display: "flex",
                                fontSize: "3em",
                            }}
                            variant="rounded"
                            alt={data.namaBarang}
                        >
                            {avatarAlt(data.namaBarang)}
                        </Avatar>
                    ) : (
                        <Avatar
                            src={undefined}
                            sx={{
                                bgcolor: "primary.main",
                                width: "30vh",
                                height: "30vh",
                                display: "flex",
                                fontSize: "3em",
                            }}
                            variant="rounded"
                            alt={data.namaBarang}
                        >
                            {avatarAlt(data.namaBarang)}
                        </Avatar>
                    )}
                </Box>
                <Box display="flex" justifyContent="center" marginY={2}>
                    <Typography variant="h6" fontWeight="bold">
                        {data.namaBarang}
                    </Typography>
                </Box>
                {data.deskripsi ? (
                    <React.Fragment>
                        <Typography variant="subtitle1">Deskripsi:</Typography>
                        <Typography variant="subtitle1">
                            {data.deskripsi}
                        </Typography>
                    </React.Fragment>
                ) : undefined}
            </DialogContent>
        </Dialog>
    );
};

export default ModalDetailBarang;
